import React, { useState, useCallback } from "react";
import "./style.less";
import { Icon, Form, Input } from "semantic-ui-react";
import { useInput } from "../../../../common/hooks";
import { useDispatch } from "react-redux";
import { searchAreaBounds } from "../../../../redux/geofence/actions";

function BoundsSearch() {
  const dispatch = useDispatch();
  const [searchBarVisible, setSearchBarVisible] = useState(false);
  const [searchBoundsInputVal, setSearchBoundsInputVal] = useInput("");

  const searchAndSetBounds = useCallback(() => {
    dispatch(searchAreaBounds(searchBoundsInputVal));
  }, [dispatch, searchBoundsInputVal]);

  const toggleSearchBar = useCallback(() => {
    setSearchBarVisible(!searchBarVisible);
    setSearchBoundsInputVal("");
  }, [searchBarVisible, setSearchBarVisible, setSearchBoundsInputVal]);

  return (
    <div className="BoundsSearch">
      <div className={searchBarVisible ? "expanded searchBar" : "searchBar"}>
        <Form onSubmit={searchAndSetBounds}>
          <Input
            placeholder={"Press enter to search"}
            value={searchBoundsInputVal}
            onChange={setSearchBoundsInputVal}
          />
        </Form>
      </div>
      <div onClick={toggleSearchBar} className="searchCta">
        <Icon name="search" />
      </div>
    </div>
  );
}

export default BoundsSearch;
